module.exports = __webpack_public_path__ + "static/media/snapchat.8627fc81.png";